import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import {Container} from 'semantic-ui-react';
import MultiPlatformField from 'components/forms/MultiPlatformField';
import ResourceFormProxy from 'classes/ResourceFormProxy';
import {getBreakResource} from "../../utils/DBUtils";
import {AutoSaveToggleBreakField, AutoSaveYesNoRadioBreakField} from "../forms/Component Sets/MultiPlatformComponents";
import blockParentUpdates from "../../hoc/blockParentUpdates";

// Only supported for MultiPlatformResourceForm right now
const ConditionalSection = (props) => (
  <Container className="conditional-section">
    <MultiPlatformField currentPlatform={props.currentPlatform}
                        fieldComponent={props.toggle ? AutoSaveToggleBreakField : AutoSaveYesNoRadioBreakField}
                        reducerKey={props.reducerKey}
                        sectionKeyPath={props.sectionKeyPath}
                        fieldKey={props.fieldKey}
                        resourcePath={props.resourcePath}
                        fieldPath={props.fieldPath}
                        field={props.field}
                        formProxy={props.formProxy}/>
    <Container className="conditional-fields">
      {
        props.value
        || (
          typeof(props.value) === 'undefined'
          && props.linkedValue
          && props.linkedValue === true
        ) ? props.children : []
      }
    </Container>
  </Container>
);

ConditionalSection.propTypes = {
  currentPlatform: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  linkedValue: PropTypes.bool,
  fieldKey: PropTypes.string.isRequired,
  formProxy: PropTypes.instanceOf(ResourceFormProxy)
};

const mapProps = (state, ownProps) => {
  let masterBreakId = state.editBreak.break.MASTER;
  let masterBreak = state.resources.resources[masterBreakId];

  let value = getBreakResource(masterBreak, masterBreak, ownProps.fieldPath);
  let linkedValue;

  let linkedFieldPath = ownProps.field && ownProps.field.linkedField ? ownProps.field.linkedField(ownProps.formProxy) : null;
  if (linkedFieldPath) {
    linkedValue = getBreakResource(masterBreak, masterBreak, linkedFieldPath);
  }

  return {
    value: value,
    linkedValue: linkedValue
  }
};

export default compose(
  blockParentUpdates,
  connect(mapProps, null)
)(ConditionalSection);



// WEBPACK FOOTER //
// ./public/components/common/ConditionalSection.jsx